'use client'

import {
  CaretDownOutlined,
  MoonOutlined,
  SettingOutlined,
  SunOutlined,
  UserOutlined,
} from '@ant-design/icons'
import {
  Avatar,
  Dropdown,
  Flex,
  Layout as AntdLayout,
  Switch,
  Button,
} from 'antd'
import { useMemo } from 'react'

import { FeatureKey } from '@/constants/feature-key'
import { selectCurrentEmployee } from '@/redux/employee-selector'
import {
  setDisplayMode,
  setIsLogin,
} from '@/redux/global'
import {
  useAppDispatch,
  useAppSelector,
} from '@/redux/utils'
import {
  getEnvDisplay,
  isDevelopment,
} from '@/utils/env'
import { disconnectWebSocket } from '@/utils/websocket'

import s from './layout-header.module.css'

const Header = AntdLayout.Header

const LOGOUT = 'LOGOUT'

export interface LayoutHeaderProps {
  onHeaderMenuClick?: (featureKey: FeatureKey[]) => void;
}

export default function LayoutHeader({
  onHeaderMenuClick,
}: LayoutHeaderProps) {
  const currentEmployee = useAppSelector(selectCurrentEmployee)
  const mode = useAppSelector((state) => state.global.displayMode)
  const dispatch = useAppDispatch()

  const menu = useMemo(() => ({
    items: [
      {
        key: LOGOUT,
        label: 'Log Out',
        onClick: () => {
          dispatch(setIsLogin(false))
          window.localStorage.clear()
          disconnectWebSocket()
        },
      },
    ],
  }), [dispatch])

  return (
    <Header className={s.mainHeader}>
      <Flex
        className={s.mainHeaderContent}
        gap={16}
        justify="flex-end"
      >
        {isDevelopment &&
          <Switch
            value={mode !== 'dark'}
            checkedChildren={<SunOutlined />}
            unCheckedChildren={<MoonOutlined />}
            onChange={() => dispatch(setDisplayMode(mode === 'dark' ? 'light' : 'dark'))}
          />
        }
        <div className={s.Version}>
          Version: {process.env.NEXT_PUBLIC_APP_VERSION} {getEnvDisplay()}
        </div>
        <Button
          type="text"
          icon={<SettingOutlined />}
          style={{ color: 'white' }}
          onClick={() => onHeaderMenuClick?.([FeatureKey.Settings])}
        />
        <Dropdown
          className={s.userInfo}
          menu={menu}
          placement="bottomRight"
          trigger={['click']}
        >
          <Flex align="center" gap={8}>
            <Avatar
              size="small"
              icon={<UserOutlined />}
              style={{ background: '#444' }}
              src={currentEmployee?.avatarUrl}
            />
            {currentEmployee?.name}
            <CaretDownOutlined />
          </Flex>
        </Dropdown>
      </Flex>
    </Header>
  )
}
